import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }
    init() {
        this.hasClicked = false;
        this.el.addEventListener( 'mousemove', () => this.addClass(), { once : true } );
        this.el.addEventListener( 'mouseenter', () => this.addClass() );
        this.el.addEventListener( 'mouseleave', () => this.removeClass() );
    }

    addClass(){
        this.call( 'add', this.el.dataset['cursor'] , 'Cursor');
    }

    removeClass(){
        this.call( 'remove', this.el.dataset['cursor'] , 'Cursor');
    }
    destroy(){
        this.call( 'remove', this.el.dataset['cursor'] , 'Cursor');
    }
}
